/**
 * Configuration constants for SSL Tools
 *
 * ONLY VALUES THE BROWSER ACTUALLY READS. Seven more lived here until
 * 2026-08-23 and nothing imported any of them : an iframe height no
 * page used, and second copies of the rate-limit window, the request
 * cap and a TLS timeout that the server owns. A second copy nobody
 * reads cannot be right or wrong, only stale, and one of them already
 * was - it gave 100 requests as though that were the whole rule, while
 * server.js runs three limiters with different ceilings. There were
 * also two bash timeouts, in a browser bundle, for a site that runs no
 * shell. The only thing keeping them alive was a test asserting each
 * literal back at itself.
 */

// Certificate validation thresholds. Read by CertificateChainDiagram to
// decide when an expiry date is close enough to warn about.
export const CERTIFICATE_EXPIRY_WARNING_DAYS = 30;

// The origin the API documentation page prints in its example requests.
export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://tools.trustico.com"
    : "http://localhost:5173";
